import React from 'react';

const PaginatorDropdown = (props) => {

    const { pageSize, onPageSizeChange, styleClasses } = props;

    return (
        <div className={`ag-grid-actions d-flex justify-content-center justify-content-md-start flex-wrap mb-3 ${styleClasses || ''}`}>
            <div className="sort-dropdown">
                <select value={pageSize} onChange={onPageSizeChange}>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="150">150</option>
                </select>
                <span>Items per page</span>
            </div>
        </div>
    )

}

export default PaginatorDropdown;